@if (data.title) {
  <div class="modal-header" role="dialog">
    <div mat-dialog-title class="title">{{ data.title  | translate}}</div>
    <mat-icon class="close-icon" (click)="cancel()">close</mat-icon>
  </div>
}
@if (data.textContent) {
  <div mat-dialog-content class="modal-content">
    <p class="dialog-text" [innerHTML]="data.textContent | translate"></p>
  </div>
}
@if (data.content) {
  <div mat-dialog-content class="modal-content">
    <ng-container [ngTemplateOutlet]="data.content"></ng-container>
  </div>
}
<div mat-dialog-actions class="modal-actions-container">
  @for (actionBtn of data.actionButtons; track actionBtn) {
    <button
      mat-icon-button
      [title]="actionBtn.tooltip || '' | translate"
      (click)="actionBtnClicked(actionBtn)"
      >
      <mat-icon>{{ actionBtn.icon }}</mat-icon>
    </button>
  }
  @if (data.cancelTextBtn) {
    <button
      mat-flat-button
      [ngClass]="data.cancelBtnClass || ''"
      id="btnConfirmationModalCancel"
      class="cancel-action"
      (click)="onClose()"
      >
      {{ data.cancelTextBtn | translate }}
    </button>
  }
  @if (data.confirmTextBtn) {
    <button
      mat-stroked-button
      class="confirm-action"
      id="btnConfirmationModalConfirm"
      dianaPreventDoubleClick
      [ngClass]="data.confirmBtnClass || ''"
      (click)="confirm()"
      >
      {{ data.confirmTextBtn | translate }}
    </button>
  }
</div>
